'use client';

import dynamic from "next/dynamic";

const PostEditButton = dynamic(
    () => import("@/components/post/PostEditButton"),
    { ssr: false }
);

export default PostEditButton;